export const formatNumber = (num, unit = "") => {
    if (typeof num !== "number") return "";
    const formattedNum = new Intl.NumberFormat("sv-SE").format(num);
    return unit ? `${formattedNum} ${unit}` : formattedNum;
  };
  